import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import ApplicationTable from './ApplicationTable';
import InvoiceTable from './InvoiceTable';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Lang from '../modules/Lang';

const styles = theme => ({

});


class Dashboard extends React.Component {

  render(){
	const h = this.context.router.history;

    const { classes, storage } = this.props;
    const { language } = storage;
    const t = Lang[language];

    console.log(this.props.applications)

	return (
	  <Card className="container" style={{ width: "85%", "textAlign": "left", padding: 20 }}>
	  	{ this.props.loading ? 
	  		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, color: "#28429e", }}>
	  			<i className="fas fa-spinner fa-10x fa-pulse"></i>
	  		</div> : 
		    <div style={{  }}>
			    <Button size="large" variant="contained" color="primary" style={{ fontSize: 20, margin: "30px 20px", padding: "5px 60px", "textTransform": "none", "borderRadius": "2px" }} onClick={()=>h.push('/account/new')} >
			        {t['dashboard.application.new']}
			    </Button>
			    
			    <Typography style={{ fontSize: 18, padding: "0 20px" }} color="textSecondary" gutterBottom >
			    	{t['dashboard.application.unconfirmed.title']}
			    </Typography>    
		    	<ApplicationTable applications={this.props.applications.filter(a=> !a.status )} />

			    <Typography style={{ fontSize: 18, padding: "0 20px" }} color="textSecondary" gutterBottom >
			    	{t['dashboard.application.confirmed.title']}
			    </Typography>    
		    	<ApplicationTable applications={this.props.applications.filter(a=> a.status && !a.paymentAt )} />		

			    <Typography style={{ fontSize: 18, padding: "0 20px" }} color="textSecondary" gutterBottom >
			    	{t['dashboard.application.paid.title']}
			    </Typography>    
		    	<ApplicationTable applications={this.props.applications.filter(a=> a.status && a.paymentAt && moment().isBefore(a.end_date) )} />		

			    <Typography style={{ fontSize: 18, padding: "0 20px" }} color="textSecondary" gutterBottom >
			    	{t['dashboard.application.expired.title']}
			    </Typography>    
		    	<ApplicationTable applications={this.props.applications.filter(a=> a.status && moment().isAfter(a.end_date) )} />				    			    	    	

		    	{/*
			    <Typography style={{ fontSize: 18, padding: "0 20px", marginTop: 40 }} color="textSecondary" gutterBottom >
			    	{t['dashboard.invoice.title']}
			    </Typography>    
		    	<InvoiceTable invoices={this.props.invoices} />    	
		    	*/}
		    </div>
		}
	  </Card> )
    }
};

Dashboard.contextTypes = {
  router: PropTypes.object.isRequired
};


const mapStateToProps = (state) => {
  return {
    storage: state.storage,
  };
};
const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(  
  mapStateToProps,
  mapDispatchToProps)
(withStyles(styles)(Dashboard));